const MODULE_NAME = 'ROLES';
const ROLES_FETCH_STARTED = MODULE_NAME + 'FETCH_STARTED';
const ROLES_FETCH_COMPLETED = MODULE_NAME + 'FETCH_COMPLETED';

export {
  ROLES_FETCH_STARTED, ROLES_FETCH_COMPLETED
};
